/**
 * Get the difference between two dates
 * @param {Date} date1
 * @param {Date} date2
 */
export const getDiffBetweenDates = (date1: Date, date2: Date): number => {
    const diffTime = Math.abs(date1.getTime() - date2.getTime())
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24))
}
